
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-madurai",
      function () {
        return require("private-next-pages/tnpsc-madurai/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-madurai"])
      });
    }
  